// Libs
import React from 'react';
import { Box, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Components
import Reorder from '../../../components/Button/ReorderButton/ReorderButton';
import Feather from '../../Feather';
import IconButton from '../../Button/IconButton/IconButton';

// Hooks
import useUser from '../../../hooks/useUser';
import useUI from '../../../hooks/useUI';
import useKitActions from '../../../pages/Kits/hooks/useKitActions';

// Utils
import { getTotalQty } from '../../../pages/Kits/utils/calculations';

// Selectors
import { productsObjSelector } from '../../../store/selectors';

// Styles
import { useStyles } from './KitAdaptiveCardStyles';

const KitAdaptiveCard = ({ kit }) => {
  const { isKiteUser } = useUser();
  const productsObj = useSelector((state) => productsObjSelector(state));
  const { onReorderClick, onDeleteClick, onViewDetailsClick, canReorder } =
    useKitActions(kit);

  const { isMobileMode } = useUI();

  const { classes, cx } = useStyles({
    isKiteUser,
    isMobileMode,
  });

  const closeButton = (
    <Feather
      data-testid="kit-remove-button"
      type="close"
      colorType="grey2"
      className={classes.favoriteIcon}
      onClick={() => onDeleteClick(kit.id)}
    />
  );

  return (
    <div className={classes.card} data-testid={'kit-card'}>
      {isMobileMode ? (
        <>
          <Typography
            data-testid={'kit-name-link-button'}
            variant="textMdSemibold"
            className={cx(classes.kitDetailsLink, classes.kitName)}
            title={kit.name}
            component={Link}
            to={`${kit.id}`}>
            {kit.name}
          </Typography>
          <Typography
            data-testid={'total-qty'}
            className={classes.mobileTotalQty}
            variant="textSmSemibold">
            Total Qty: {getTotalQty(kit, productsObj)}
          </Typography>
          <Reorder
            disabled={!canReorder}
            kit={kit}
            onClick={onReorderClick}
            className={classes.reorderButton}
            inTable
          />
        </>
      ) : (
        <>
          <Box display="flex" flexDirection="column" flexBasis="300px">
            <Typography
              data-testid={'kit-name'}
              variant="h3"
              className={classes.kitName}
              title={kit.name}>
              {kit.name}
            </Typography>
            <IconButton
              data-testid={'kit-details-button'}
              onClick={() => onViewDetailsClick(kit?.id)}
              endIcon={<ChevronRightIcon className={classes.chevron} />}
              className={classes.flatIconButton}>
              Details
            </IconButton>
          </Box>
          <Box display="flex" justifyContent="center">
            <div data-testid={'total-qty'}>
              <Typography variant="h4">Total Qty:</Typography>
              <Typography
                className={classes.tabletTotalQtyValue}
                variant="textSmSemibold">
                {getTotalQty(kit, productsObj)}
              </Typography>
            </div>
          </Box>

          <Box display="flex" justifyContent="center">
            <Reorder
              disabled={!canReorder}
              kit={kit}
              onClick={onReorderClick}
              className={classes.reorderButtonWide}
              inTable
            />
          </Box>
        </>
      )}
      {closeButton}
    </div>
  );
};

export default KitAdaptiveCard;
